import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'
import { computed, inject, ref, watch, watchEffect } from 'vue'
import { storeToRefs } from 'pinia'

import { useCommandStore } from './useCommandStore'
import { optionsInjectionKey } from './utils'

interface CommandInputProps {
  value?: string
  placeholder?: string
  twClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CommandInput',
  props: {
    value: null,
    placeholder: null,
    twClass: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: string
  placeholder?: string
  twClass?: string
};




const { storeId } = inject(optionsInjectionKey, {
  shouldFilter: true,
  storeId: '',
})

const commandStore = useCommandStore(storeId)
const { search: searchState } = storeToRefs(commandStore)

const inputRef = ref<HTMLInputElement | null>(null)

const search = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
  },
})

watch(
  search,
  (newSearch) => {
    searchState.value = newSearch ?? ''
  },
  { immediate: true },
)

watchEffect(() => {
  inputRef.value?.focus()
})

return { __sfc: true,props, emit, storeId, commandStore, searchState, inputRef, search, twMerge }
}

})